import { FourOhFour } from '@cimpress/react-components';
import { NavLink } from 'react-router-dom';

export type NotFoundStateProps = {
  message: string;
  navigationLink: {
    to: string;
    text: string;
  };
};

const NotFoundState = ({ message, navigationLink }: NotFoundStateProps) => {
  return (
    <FourOhFour
      message={
        <p>
          {message} Go back to{' '}
          <NavLink to={navigationLink.to}>{navigationLink.text}</NavLink>.
        </p>
      }
    />
  );
};

export default NotFoundState;
